import '@src/commonDependencies';
import './css/Common.scss';
import './css/Template.scss';
import './css/QStrap.scss';
import './css/Theme.scss';
import './css/Login.scss';
import { LoginForm } from './components/Component/Container/Form/LoginForm/LoginForm.js';
import { ForgotPasswordForm } from '@components/Component/Container/Form/ForgotPasswordForm/ForgotPasswordForm.js';
import { ResetPasswordForm } from '@components/Component/Container/Form/ResetPasswordForm/ResetPasswordForm.js';
import { Login } from '@components/Component/Container/Application/Login/Login.js';
import { createComponentsFromDOM } from '@components/Utility/index.js';
import DIContainer, { patchWebpackChunkVersion } from '@components/DependencyInjectionContainer.js';
import { ENV } from '@components/Environment.js';
import { Input } from '@components/Component/Field/Input/Input.js';
import { InputPassword } from '@components/Component/Field/Input/InputPassword/InputPassword.js';
import { Button } from '@components/Component/Button/Button.js';
import { TextBase } from '@components/Component/TextBase/TextBase.js';
import { ConditionsManager } from '@components/ConditionsManager/ConditionsManager.js';
import { getCookie } from '@components/Utility/index.js';
import { Radio } from '@components/Component/Field/Radio/Radio.js';
import { InputAuthCode } from '@components/Component/Field/Input/InputAuthCode/InputAuthCode.js';
import { InputCheckbox } from '@components/Component/Field/Input/InputCheckbox/InputCheckbox.js';
ENV('appName', 'login');
window.DIContainer = DIContainer;
DIContainer.registerSingleton('Application', (id, rootElement) => {
    return new Login('application', rootElement);
});
DIContainer.register('Input', Input);
DIContainer.register('InputPassword', InputPassword);
DIContainer.register('InputAuthCode', InputAuthCode);
DIContainer.register('InputCheckbox', InputCheckbox);
DIContainer.register('Button', Button);
DIContainer.register('TextBase', TextBase);
DIContainer.register('Radio', Radio);
DIContainer.register('LoginForm', LoginForm);
DIContainer.register('ForgotPasswordForm', ForgotPasswordForm);
DIContainer.register('ResetPasswordForm', ResetPasswordForm);
DIContainer.registerSingleton('ConditionsManager', ConditionsManager);
document.title = 'Q360 Login';
/**
 * Define all the routes for the login application.
 */
const screenRouter = DIContainer.getInstance('ScreenRouter');
screenRouter.addRoute({ path: '', componentName: 'LoginForm' });
screenRouter.addRoute({ path: 'forgotpassword', componentName: 'ForgotPasswordForm' });
screenRouter.addRoute({ path: 'resetpassword', componentName: 'ResetPasswordForm' });
// route not found action
screenRouter.addRoute({ path: '*', componentName: 'LoginForm' });
window.addEventListener('DOMContentLoaded', function () {
    patchWebpackChunkVersion(ENV('clientVersion') + '.' + (ENV('hotfixVersion') || '0'));
    const app = DIContainer.getInstance('Application');
    if (app.requestParams?._basepath) {
        ENV('baseUrl', ENV('baseUrl') + app.requestParams._basepath);
        delete app.requestParams?._basepath;
    }
    const theme = getCookie('login-theme');
    if (theme) {
        app.updateTheme(theme);
    }
    app.configReady$()
        .subscribe(() => {
        if (app.requestParams?._error) {
            app.alert({ caption: app.requestParams?._error, modalStyle: 'error' });
            delete app.requestParams?._error;
        }
        createComponentsFromDOM(document);
        app.start(app.requestParams);
    });
});
export { DIContainer, ENV };
